"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppChat = exports.AppChatContextProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useChat = require("./useChat");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var AppChatContext = /*#__PURE__*/_react.default.createContext({});
var useAppChat = function useAppChat() {
  return (0, _react.useContext)(AppChatContext);
};

/**
 * Context that initializes chat client for each app
 */
exports.useAppChat = useAppChat;
var AppChatContextProvider = function AppChatContextProvider(_ref) {
  var children = _ref.children;
  var chatProps = (0, _useChat.useChat)();
  return /*#__PURE__*/_react.default.createElement(AppChatContext.Provider, {
    value: chatProps
  }, children);
};
exports.AppChatContextProvider = AppChatContextProvider;